// @flow
import { handleResponseOld, handleResponseWithNon200Errors, makeGet, makePost, makePut } from './helpers';
import { type Address } from '@liveauctioneers/caterwaul-components/types/Address';
import { type StripeBillingAddress } from '../../types/StripeBillingAddress';

type PostAddStripeCardParams = {
    authToken: string,
    bidderId: number,
    cardToken: string,
    deployment: string,
};

export const postAddStripeCard = ({ authToken, bidderId, cardToken, deployment }: PostAddStripeCardParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({
            authToken,
            deployment,
            path: `<MAINHOST-API>api/bidders/${bidderId}/stripe/customer`,
        });
        request.send({ card_token: cardToken });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

type PostAddLACardParams = {
    authToken: string,
    bidderId: number,
    billingAddress: Address,
    cardholderName: string,
    cardNonce: string,
    deployment: string,
    providerId: number,
};

export const postAddLACard = ({
    authToken,
    bidderId,
    billingAddress,
    cardNonce,
    cardholderName,
    deployment,
    providerId,
}: PostAddLACardParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({
            authToken,
            deployment,
            path: `<PAYMENT-API>cards/${bidderId}`,
        });
        request.send({
            billingAddress,
            cardholderName,
            cardNonce,
            providerId,
        });
        request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
    });

type PostStripePaymentParams = {
    address: StripeBillingAddress,
    amount: number,
    authToken: string,
    bidderId: number,
    cardToken: any,
    catalogId: number,
    currency: string,
    deployment: string,
    sessionId: string,
};

export const postStripePayment = ({
    address: shipping_address,
    amount,
    authToken,
    bidderId,
    cardToken: card_token,
    catalogId,
    currency,
    deployment,
    sessionId,
}: PostStripePaymentParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({
            authToken,
            deployment,
            path: `<MAINHOST-API>api/bidders/${bidderId}/wonitems/catalogs/${catalogId}/payments`,
        });
        request.send({ amount, card_token, currency, sessionId, shipping_address });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

type PostLAPaymentParams = {
    address: Address,
    authToken: string,
    bidderId: number,
    deployment: string,
    invoiceId: string,
};

export const postLAPayment = ({
    address: shippingAddress,
    authToken,
    bidderId,
    deployment,
    invoiceId,
}: PostLAPaymentParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({
            authToken,
            deployment,
            path: `<MAINHOST-API>api/bidders/${bidderId}/checkout/${invoiceId}`,
        });
        request.send({
            shippingAddress: {
                //$FlowFixMe these exist on the type at runtime, will be cleaned up in OP-235
                addressLine1: shippingAddress.address,
                addressLine2: shippingAddress.address2,
                city: shippingAddress.city,
                //$FlowFixMe these exist on the type at runtime, will be cleaned up in OP-235
                country: shippingAddress.country,
                //$FlowFixMe these exist on the type at runtime, will be cleaned up in OP-235
                phoneNumber: shippingAddress.mobileNumber,
                //$FlowFixMe these exist on the type at runtime, will be cleaned up in OP-235
                postalCode: shippingAddress.zip,
                state: shippingAddress.state,
            },
        });
        request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
    });

type PutAddStripeCardParams = {
    authToken: string,
    bidderId: number,
    cardToken: string,
    deployment: string,
};

export const putAddStripeCard = ({ authToken, bidderId, cardToken, deployment }: PutAddStripeCardParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePut({
            authToken,
            deployment,
            path: `<MAINHOST-API>api/bidders/${bidderId}/stripe/customer`,
        });
        request.send({ card_token: cardToken });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

type GetLAPaymentCardsParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
};

export const getLAPaymentCards = ({ authToken, bidderId, deployment }: GetLAPaymentCardsParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({
            authToken,
            deployment,
            path: `<PAYMENT-API>cards/${bidderId}`,
        });
        request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
    });
